import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Footer from "../../CustomComponents/Footer/Footer.jsx";
import PageMetaData from "../../CustomComponents/PageMetaData/PageMetaData.jsx";
import OgMetaTitles from "../../CustomComponents/PageMetaData/OgMetaTitles.jsx";
import CustomSearchFormTransport from "../../CustomComponents/SearchForm/CustomSearchFormActivities/CustomSearchFormTransport.jsx";
import Header from "../../CustomComponents/Header/Header.jsx";
import imgNotFound from "../../assets/images/single-image.png";
import Testimonial from "../../CustomComponents/Testimonial/Testimonial.jsx";
import Highlights from "../../CustomComponents/Highlights/Highlights.jsx";
import Slider from "react-slick";
import { currentDateSingle } from "../../utils/utils.js";
import NewFooterUI from "../../CustomComponents/NewComponents/NewFooterUI/NewFooterUI.jsx";
import DestinationGallery from "../../CustomComponents/NewComponents/NewDestinationSection/DestinationGallery.jsx";
import NewUIBookWithUs from "../../CustomComponents/NewComponents/NewUIBookWithUs/NewUIBookWithUs.jsx";
import NewUiSearchFormTransport from "../../CustomComponents/NewComponents/NewUiSearchForm/NewUiSearchFormTransport/NewUiSearchFormTransport.jsx";
import NewUiHeader from "../../CustomComponents/NewComponents/NewUIHeader/NewUIHeader.jsx";
import TransportCard from "../../CustomComponents/NewComponents/NewUiTransport/NewUITransportCard.jsx";
import styles from "./Transport.module.scss";
import NewTestimonial from "../../CustomComponents/NewComponents/NewTestimonial/NewTestimonial.jsx";
import NoDataFound from "../../CustomComponents/NoDataFound/NoDataFound.jsx";
import testimonialImg from "../../assets/images/new-testimonial.png";
import Skeleton from "react-loading-skeleton";

function Transport() {
  const [footerDestinations, setFooterDestinations] = useState([]);
  const navigate = useNavigate();
  const [loader, setLoader] = useState(false);

  const [date, setDate] = useState(new Date());
  useEffect(() => {
    // const isVerifiedToken = localStorage.getItem('isVerified');
    const AccountStatus = localStorage.getItem("AccountStatus");
    // console.log(AccountStatus, "AccountStatus")
    // const role = localStorage.getItem('role');

    // console.log(isVerifiedToken, "token");
    // console.log(role, "role");

    if (AccountStatus === "disable") {
      console.error("Error: Invalid token or undefined for agent role");
      // showErrorToast("First Fill all required ")
      navigate("/agent-account");
    }
  }, [navigate]);

  const fetchDestinations = async () => {
    setLoader(true);

    const myHeaders = new Headers();
    myHeaders.append("Accept", "application/json");
    myHeaders.append("key", process.env.REACT_APP_BASE_API_KEY);
    // myHeaders.append(
    //   "Authorization",
    //   "Bearer " + localStorage.getItem("token")
    // );

    const formData = new FormData();

    formData.append("limit", 10);

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      redirect: "follow",
      body: formData,
    };

    try {
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/api/v1/destinations/fetch`,
        requestOptions
      );
      const result = await response.json();
      setFooterDestinations(result?.data?.slice(0, 7));
    } catch (error) {
      console.error(error);
    } finally {
      setLoader(false); // Ensure loader is turned off
    }
  };

  useEffect(() => {
    fetchDestinations();
  }, []);

  const hubs = [
    {
      id: 1,
      name: "Ex Chandigarh",
      status: true,
    },
    {
      id: 2,
      name: "Ex Delhi",
      status: true,
    },
    {
      id: 3,
      name: "Ex Amritsar",
      status: true,
    },
  ];

  var settings = {
    slidesToShow: 4,
    speed: 500,
    arrows: false,
    infinite: false,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          centerPadding: "40px",
          slidesToShow: 4,
          arrows: false,
        },
      },
      {
        breakpoint: 500,
        settings: {
          slidesToShow: 2.5,
          arrows: false,
        },
      },
      {
        breakpoint: 424,
        settings: {
          slidesToShow: 2,
          arrows: false,
        },
      },
    ],
  };

  const handleSubmitButtonClickHandlerActivity = async (startDestination) => {
    // if (e) {
    //     e.preventDefault();
    // }

    setLoader(true);

    const selectedMultipleDestinations = [startDestination];

    const fallbackDate = new Date();
    fallbackDate.setDate(fallbackDate.getDate() + 7);

    try {
      await navigate(
        `/transport/listing?startdestination=${startDestination}&noOfDays=5&date=${fallbackDate.getDate()}&month=${fallbackDate.getMonth() + 1}&year=${fallbackDate.getFullYear()}`,
        {
          state: {
            includingDestinations: selectedMultipleDestinations,
          },
        },
        undefined,
        { shallow: false }
      );
    } catch (error) {
      console.error("Error fetching data:", error);
      setLoader(false);
    } finally {
      setLoader(false);
    }
  };

  return (
    <div id="transport">
      <PageMetaData
        title="Transport Packages -  Mountain Mysteries"
        // description="Book hotels in Himachal Pradesh at the best budget tariffs. Explore our curated list of luxury and budget hotels with the best available prices. Compare rates and find the perfect stay with us!"
        keywords="book cabs in himachal pradesh"
      />
      {/*
      <OgMetaTitles
        title="The Best Hotels in Himachal Pradesh, India -  Mountain Mysteries"
        type="Book hotels in Himachal Pradesh at the best budget tariffs. Explore our curated list of luxury and budget hotels with the best available prices. Compare rates and find the perfect stay with us!"
        url="https://www.mountainmysteries.com/accommodation/"
      /> */}
      {/* <CustomSearchFormTransport
        topRadios={["Hotel", "B&B", "Camping", "HomeStay"]}
      /> */}

      <NewUiHeader />
      <NewUiSearchFormTransport />
      {/* <section className="common_padding">
        <div className="container">
          <TransportCard />
        </div>
      </section> */}
      {/* <section className="new_ui_bg">
        <DestinationGallery footerDestinations={footerDestinations} />
      </section> */}

      <section className="top_bottom_same_padding new_ui_bg">
        <div className="container">
          {loader ? (
            <div>
              <div className={`${styles.destination_gallery} `}>
                {Array.from({ length: 7 }).map((_, index) => (
                  <div
                    className={styles[`destination${index + 1}`]}
                    key={index}
                  >
                    <Skeleton width={800} height={300} />
                  </div>
                ))}
              </div>
            </div>
          ) : (
            <>
              <h3 className="new_ui_heading">Top Himachal Destinations</h3>

              <div className={`${styles.destination_gallery} m_0`}>
                {footerDestinations?.length > 0 ? (
                  footerDestinations.map((item, index) => (
                    <div
                      className={styles[`destination${index + 1}`]}
                      key={index}
                      onClick={() =>
                        handleSubmitButtonClickHandlerActivity(item?.name)
                      }
                    >
                      <img
                        src={item?.featuredImage || imgNotFound}
                        alt={item?.name}
                      />
                      <span className={styles.span_text}>{item?.name}</span>
                    </div>
                  ))
                ) : (
                  <>
                    <NoDataFound />
                  </>
                )}
              </div>
            </>
          )}
        </div>
      </section>
      <section className="common_padding_testimonial">
        <div className="container">
          {" "}
          <div className="testimonial_flex_sec">
            <div>
              {" "}
              <h4 className="text_left new_ui_heading mb-10">
                Our Customers are Saying...
              </h4>
              <div className="google_rating">
                <div>
                  {" "}
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M21.8055 10.0415H21V10H12V14H17.6515C16.827 16.3285 14.6115 18 12 18C8.6865 18 6 15.3135 6 12C6 8.6865 8.6865 6 12 6C13.5295 6 14.921 6.577 15.9805 7.5195L18.809 4.691C17.023 3.0265 14.634 2 12 2C6.4775 2 2 6.4775 2 12C2 17.5225 6.4775 22 12 22C17.5225 22 22 17.5225 22 12C22 11.3295 21.931 10.675 21.8055 10.0415Z"
                      fill="#FFC107"
                    />
                    <path
                      d="M3.15283 7.3455L6.43833 9.755C7.32733 7.554 9.48033 6 11.9998 6C13.5293 6 14.9208 6.577 15.9803 7.5195L18.8088 4.691C17.0228 3.0265 14.6338 2 11.9998 2C8.15883 2 4.82783 4.1685 3.15283 7.3455Z"
                      fill="#FF3D00"
                    />
                    <path
                      d="M12.0002 22C14.5832 22 16.9302 21.0115 18.7047 19.404L15.6097 16.785C14.5721 17.5745 13.3039 18.0014 12.0002 18C9.39916 18 7.19066 16.3415 6.35866 14.027L3.09766 16.5395C4.75266 19.778 8.11366 22 12.0002 22Z"
                      fill="#4CAF50"
                    />
                    <path
                      d="M21.8055 10.0415H21V10H12V14H17.6515C17.2571 15.1082 16.5467 16.0766 15.608 16.7855L15.6095 16.7845L18.7045 19.4035C18.4855 19.6025 22 17 22 12C22 11.3295 21.931 10.675 21.8055 10.0415Z"
                      fill="#1976D2"
                    />
                  </svg>{" "}
                  RATING
                </div>
                <div className="mt-10">
                  <span> 4.7</span>{" "}
                  <svg
                    width="18"
                    height="18"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <mask
                      id="mask0_6890_8390"
                      style={{ maskType: "alpha" }}
                      maskUnits="userSpaceOnUse"
                      x="0"
                      y="0"
                      width="18"
                      height="18"
                    >
                      <rect width="20" height="20" fill="#D9D9D9" />
                    </mask>
                    <g mask="url(#mask0_6890_8390)">
                      <path
                        d="M4.85352 17.5L6.79102 11.1667L1.66602 7.50003H7.99935L9.99935 0.833359L11.9993 7.50003H18.3327L13.2077 11.1667L15.1452 17.5L9.99935 13.5834L4.85352 17.5Z"
                        fill="#ECB119"
                      />
                    </g>
                  </svg>
                  <svg
                    width="18"
                    height="18"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <mask
                      id="mask0_6890_8390"
                      style={{ maskType: "alpha" }}
                      maskUnits="userSpaceOnUse"
                      x="0"
                      y="0"
                      width="18"
                      height="18"
                    >
                      <rect width="20" height="20" fill="#D9D9D9" />
                    </mask>
                    <g mask="url(#mask0_6890_8390)">
                      <path
                        d="M4.85352 17.5L6.79102 11.1667L1.66602 7.50003H7.99935L9.99935 0.833359L11.9993 7.50003H18.3327L13.2077 11.1667L15.1452 17.5L9.99935 13.5834L4.85352 17.5Z"
                        fill="#ECB119"
                      />
                    </g>
                  </svg>
                  <svg
                    width="18"
                    height="18"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <mask
                      id="mask0_6890_8390"
                      style={{ maskType: "alpha" }}
                      maskUnits="userSpaceOnUse"
                      x="0"
                      y="0"
                      width="18"
                      height="18"
                    >
                      <rect width="20" height="20" fill="#D9D9D9" />
                    </mask>
                    <g mask="url(#mask0_6890_8390)">
                      <path
                        d="M4.85352 17.5L6.79102 11.1667L1.66602 7.50003H7.99935L9.99935 0.833359L11.9993 7.50003H18.3327L13.2077 11.1667L15.1452 17.5L9.99935 13.5834L4.85352 17.5Z"
                        fill="#ECB119"
                      />
                    </g>
                  </svg>
                  <svg
                    width="18"
                    height="18"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <mask
                      id="mask0_6890_8390"
                      style={{ maskType: "alpha" }}
                      maskUnits="userSpaceOnUse"
                      x="0"
                      y="0"
                      width="18"
                      height="18"
                    >
                      <rect width="20" height="20" fill="#D9D9D9" />
                    </mask>
                    <g mask="url(#mask0_6890_8390)">
                      <path
                        d="M4.85352 17.5L6.79102 11.1667L1.66602 7.50003H7.99935L9.99935 0.833359L11.9993 7.50003H18.3327L13.2077 11.1667L15.1452 17.5L9.99935 13.5834L4.85352 17.5Z"
                        fill="#ECB119"
                      />
                    </g>
                  </svg>
                  <svg
                    width="18"
                    height="18"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <mask
                      id="mask0_6890_8399"
                      style={{ maskType: "alpha" }}
                      maskUnits="userSpaceOnUse"
                      x="0"
                      y="0"
                      width="18"
                      height="18"
                    >
                      <rect width="20" height="20" fill="#D9D9D9" />
                    </mask>
                    <g mask="url(#mask0_6890_8399)">
                      <path
                        d="M9.99935 6.58336V11.5L11.9993 13.0417L11.2493 10.5L13.1243 9.16669H10.791L9.99935 6.58336ZM4.85352 17.5L6.79102 11.1667L1.66602 7.50003H7.99935L9.99935 0.833359L11.9993 7.50003H18.3327L13.2077 11.1667L15.1452 17.5L9.99935 13.5834L4.85352 17.5Z"
                        fill="#ECB119"
                      />
                    </g>
                  </svg>
                </div>
              </div>
            </div>

            <div className="slider_sec">
              <NewTestimonial />{" "}
            </div>
          </div>
        </div>
      </section>

      <NewUIBookWithUs />
      <NewFooterUI />

      {/* <Testimonial />
      <Highlights /> */}
      {/* <Footer /> */}
    </div>
  );
}

export default Transport;

// <div className="container">
// <div className="common_padding">
//   <div className="flex justify_content_center align_items_end">
//     <h3>Top Transport Destinations</h3>
//   </div>
// </div>
// {/* {hubs &&
//     hubs?.map((item, index) => (
//       <div className="destination_link transport_hubs_card" key={index}>
//         {item.images && item.images.length > 0 ? (
//           <img src={item.images[0]} alt={item.name} />
//         ) : (
//           <img src={imgNotFound} alt="Image not found" />
//         )}
//         <div className="destination_name">
//           <h6>{item.name}</h6>
//         </div>
//       </div>
//     ))} */}

// <div className="images-flex">
//   <Slider {...settings}>
//     {footerDestinations?.map((items, index) => {
//       return (
//         <div
//           // onClick={() =>
//           //   scroll.scrollToTop({
//           //     duration: 500,
//           //     smooth: "easeInOutQuad",
//           //   })
//           // }
//           // to={`/destination/${items.name.toLowerCase()}`}
//           className="destination_link"
//           key={index}
//           onClick={() => handleSubmitButtonClickHandlerActivity(items?.name)}
//         >

//           {items.images && items.images.length > 0 ?
//             <img src={items.images[0]} alt={items.alt} />
//             : <img src={imgNotFound} alt='Image not found' />
//           }

//           <div className="destination_name">
//             <h6>{items.name}</h6>
//           </div>
//         </div>
//       );
//     })}
//   </Slider>
// </div>
// </div>
